import HeaderValidation from "../../Dashboard/Visitor/External/Components/HeaderValidation";
import React from "react";
import { ForgotPasswordApp } from "../Functionality/ForgotPasswordApp";
import HomeAnimatedBackground from "./HomeAnimatedBackground";
import StepsForgotPassword from "./Steps/StepsForgotPassword";
import DivContainerBody from "../../../components/DivContainerBody";
import FullPageLoader from "../../../utils/FullPageLoader";
import EnterEmailAddress from "./Steps/EnterEmailAddress";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 19 de 05 de 2026
 */


const ForgotPassword = () => {

    const {
        t,
        stepModel,
        activeStep,
        emptyFields,
        otp,
        setOtp,
        handleEmailChange,
        handleEmailSend,
        handleSelectFlow,
        handleNavigateBack,
        email,
        setEmail,
        handleKeyDown,
        isValidEmail,
        canResendOtp,
        minutes,
        seconds,
        handleValidateOtp,
        setIsValidOtp,
        isValidOtp,
        handleResendOtp,
        loading,
        handleSavePassword,
        password,
        setPassword,
        confirmPassword,
        setConfirmPassword,
        setTouched,
        barClass,
        allPassed,
        ruleList,
        ruleClass,
        passwordsMatch,
        canSave,
        secretModal,
        setSecretModal,
        secretKey,
        setSecretKey
    } = ForgotPasswordApp();

    return (
        <div className={'d-flex w-100vw h-100vh overflow-hidden row'}>
            <div className="col-12 col-lg-7 p-0 d-none d-lg-block">
                <HomeAnimatedBackground t={t} />
            </div>
            <div className="col-12 col-lg-5 flex-fill d-flex flex-column justify-content-center align-items-center position-relative">
                <div className={"h-100 w-100 d-flex flex-column"}>
                    <HeaderValidation
                        activeStep={activeStep}
                        steps={false}
                        activeProgressBar={false}
                        click={handleNavigateBack}
                        showBtnBack={
                            !(stepModel && (activeStep === stepModel.STEPS.SUCCESS))
                        }
                    />
                    <DivContainerBody>
                        {!stepModel ? (
                            <EnterEmailAddress t={t} email={email} setEmail={setEmail} handleEmailChange={handleEmailChange}
                                               handleKeyDown={handleKeyDown} isValidEmail={isValidEmail} handleEmailSend={handleEmailSend}
                                               emptyFields={emptyFields} />
                        ) : (
                            <StepsForgotPassword
                                t={t}
                                activeStep={activeStep}
                                stepModel={stepModel}
                                email={email}
                                setEmail={setEmail}
                                handleEmailChange={handleEmailChange}
                                handleKeyDown={handleKeyDown}
                                isValidEmail={isValidEmail}
                                emptyFields={emptyFields}
                                handleEmailSend={handleEmailSend}
                                canResendOtp={canResendOtp}
                                minutes={minutes}
                                seconds={seconds}
                                handleValidateOtp={handleValidateOtp}
                                otp={otp}
                                setOtp={setOtp}
                                setIsValidOtp={setIsValidOtp}
                                isValidOtp={isValidOtp}
                                handleResendOtp={handleResendOtp}
                                handleSavePassword={handleSavePassword}
                                password={password}
                                setPassword={setPassword}
                                confirmPassword={confirmPassword}
                                setConfirmPassword={setConfirmPassword}
                                setTouched={setTouched}
                                barClass={barClass}
                                allPassed={allPassed}
                                ruleList={ruleList}
                                ruleClass={ruleClass}
                                passwordsMatch={passwordsMatch}
                                canSave={canSave}
                                secretModal={secretModal}
                                setSecretModal={setSecretModal}
                                secretKey={secretKey}
                                setSecretKey={setSecretKey}
                                handleSelectFlow={handleSelectFlow}
                            />
                        )}

                        {loading && <FullPageLoader/>}
                    </DivContainerBody>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
